var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "social/youtube"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3621 22.0063C27.1593 20.6401 27.4999 18.4371 27.4999 14.8535C27.4999 11.2842 27.1625 9.094 26.3568 7.69114C25.5494 6.23436 24.5918 5.77197 22.6913 5.66099C21.3938 5.57305 18.1692 5.52344 14.6697 5.52344C11.1626 5.52344 7.9366 5.57303 6.62942 5.66168C4.73955 5.77224 3.78171 6.23565 2.96717 7.69647C2.1732 9.09449 1.83325 11.2954 1.83325 14.8666C1.83325 18.4175 2.17485 20.6294 2.97415 22.0229C3.7781 23.4649 4.72067 23.9227 6.62662 24.0566C7.99647 24.1367 11.4051 24.1901 14.6697 24.1901C17.927 24.1901 21.3339 24.1367 22.6913 24.0575C24.6147 23.9227 25.5571 23.4642 26.3621 22.0063ZM22.5444 7.98967C23.7332 8.05914 23.9536 8.166 24.3305 8.84801C24.8791 9.7981 25.1666 11.6574 25.1666 14.8666C25.1666 18.0514 24.8775 19.921 24.333 20.8546C23.9549 21.5387 23.736 21.6453 22.5417 21.729C21.257 21.8039 17.8831 21.8568 14.6697 21.8568C11.4491 21.8568 8.07345 21.8039 6.77645 21.7281C5.59693 21.6452 5.37484 21.5373 5.00511 20.8742C4.45692 19.9184 4.16659 18.0383 4.16659 14.8535C4.16659 11.6706 4.45538 9.80089 5.00063 8.84076C5.37612 8.16742 5.59977 8.05922 6.77653 7.99034C8.02251 7.90589 11.2182 7.85677 14.6697 7.85677C18.1138 7.85677 21.308 7.90591 22.5444 7.98967ZM12.3333 11.3568L18.1666 14.8568L12.3333 18.3568V11.3568Z",
    fill: "#005FC8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialYoutube);
export default __webpack_public_path__ + "static/media/social-youtube.49922bcd.svg";
export { ForwardRef as ReactComponent };